var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"space-xl"}),_c('div',{staticClass:"m-b-l"},[_c('div',{staticClass:"box-blue p-all-l"},[_c('div',[_c('h6',{staticClass:"ft-basic"},[_vm._v(" "+_vm._s(_vm.setTitle())+" ")])])]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }